/** @jsx jsx */
import { useBreakpointIndex } from "@theme-ui/match-media";
import { FC } from "react";
import { jsx } from "theme-ui";

import { TimeReport } from "@/data/time-reports";

import { TimeReportCalendarDesktop } from "./_components/TimeReportCalendarDesktop";
import { TimeReportCalendarMobile } from "./_components/TimeReportCalendarMobile";

interface TimeReportCalendarProps {
  timeReport: TimeReport;
  editable?: boolean;
}

export const TimeReportCalendar: FC<TimeReportCalendarProps> = ({ timeReport, editable }) => {
  const breakpoint = useBreakpointIndex();

  return breakpoint >= 3 ? (
    <TimeReportCalendarDesktop timeReport={timeReport} editable={editable} />
  ) : (
    <TimeReportCalendarMobile timeReport={timeReport} editable={editable} />
  );
};
